import React from "react";
import { inject, observer } from "mobx-react";
import { PopupHint } from "@op/opds.opux";
import { Message, useMessageGetter } from "react-message-context";
import {
  emptyError,
  invalidTextAreaError,
  isBlank,
  resolveMaxRows,
  isValidText,
} from "../../../utils/commonUtils";
import TextArea from "./TextArea";

const FeedbackText = observer(({ FeedbackStore }) => {
  const key = "text";
  const { feedback, updateError, updateValue, updateIncluded } = FeedbackStore;
  const text = feedback.text;
  const msgs = useMessageGetter("feedback.form.text");
  const moreInfo = useMessageGetter("feedback.form.moreInformation");
  const popupHintLabel = `${moreInfo("label")}: ${msgs("label")}`;

  updateIncluded(key, true);

  const handleOnChange = (value) => {
    updateError(key, isValidText(value) ? false : invalidTextAreaError());
    updateValue(key, value);
  };

  const handleOnBlur = () => {
    if (isBlank(text.value)) updateError(key, emptyError(msgs));
  };

  return (
    <div className="rof-feedbackText">
      <TextArea
        id={`ROF-${key}`}
        translations={msgs}
        value={text.value}
        error={text.error}
        rows={3}
        maxRows={resolveMaxRows()}
        maxLength={4000}
        handleOnChange={handleOnChange}
        handleOnBlur={handleOnBlur}
        required={true}
        counter={true}
        hint={
          <PopupHint label={popupHintLabel}>
            <Message id="feedback.form.text.hint" />
          </PopupHint>
        }
        describedBy="ROF-sensitiveInfo"
      />
    </div>
  );
});

export default inject("FeedbackStore")(FeedbackText);
